import { render, staticRenderFns } from "./smsDeposit.vue?vue&type=template&id=463c617e&scoped=true&"
import script from "./smsDeposit.vue?vue&type=script&lang=js&"
export * from "./smsDeposit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463c617e",
  null
  
)

export default component.exports